
export const loadProfit = (load) => {
 const customerRate = load?.customerRate - (load?.bill?.prepay ? load?.bill?.prepay : 0) -  (load?.bill?.noProfitAmt ? load?.bill?.noProfitAmt : 0);
 const carrierRate = load?.carrierRate - load.payable.noProfitAmt;
 return customerRate - carrierRate - load?.agentCharges;
}